import { Rpc } from '../rpc';
import { RpcInboundClient } from '../rpc-inbound-client';
import { RpcWorkItem, RpcWorkItemKey, RpcWorkItemResult } from './rpc-work-item-model';

export class RpcWorkItemClient {
    /**
     * The work item command.
     *
     * @param data the work item object.
     * @return Promise<RpcWorkItemResult> the promise object of work item result.
     */
    public static submitOrQueryWorkItem(rpc: Rpc, data: RpcWorkItem): Promise<RpcWorkItemResult> {
        return RpcInboundClient.call(rpc, RpcWorkItemKey.command, RpcWorkItemKey.version, data);
    }
}
